import React from 'react';
import './References.css';

const References = () => {
  const references = [
    {
      "authors": "Hurrell Jr JJ, Murphy, LR.",
      "year": "1996",
      "title": "Occupational stress intervention",
      "journal": "American Journal of Industrial Medicine",
      "volume": "29",
      "number": "4",
      "pages": "338-341",
      "type": "journal"
    },
    {
      "authors": "牛琼, 刘继文.",
      "year": "2015",
      "title": "中学教师职业紧张水平与工作能力的相关关系分析",
      "journal": "新疆医科大学学报",
      "volume": "38",
      "number": "09",
      "pages": "1182-1184+1188",
      "type": "journal"
    },
    {
      "authors": "Leung SSK, Chiang VCL, Chui YY, et al.",
      "year": "2011",
      "title": "A brief cognitive‐behavioral stress management program for secondary school teachers",
      "journal": "Journal of Occupational Health",
      "volume": "53",
      "number": "1",
      "pages": "23-35",
      "type": "journal"
    },
    {
      "authors": "Yang R, You X, Zhang Y, et al.",
      "year": "2019",
      "title": "Teachers’ mental health becoming worse: the case of China",
      "journal": "International Journal of Educational Development",
      "volume": "70",
      "pages": "102077",
      "type": "journal"
    },
    {
      "authors": "Bolton D.",
      "year": "2023",
      "title": "A revitalized biopsychosocial model: core theory, research paradigms, and clinical implications",
      "journal": "Psychological Medicine",
      "pages": "1-8",
      "type": "journal"
    },
    {
      "authors": "王瑾, 张巧耘, 陈惠清, 等.",
      "year": "2020",
      "title": "中国职业人群职业紧张测量核心量表编制",
      "journal": "中华预防医学杂志",
      "volume": "54",
      "number": "10",
      "pages": "1184-1189",
      "type": "journal"
    },
    {
      "authors": "王瑾, 刘晓曼, 孙彦彦, 等.",
      "year": "2020",
      "title": "中国制造业工人和医务人员职业紧张测量核心量表常模的研制",
      "journal": "中华预防医学杂志",
      "volume": "54",
      "number": "11",
      "pages": "1190-1196",
      "type": "journal"
    },
    {
      "authors": "王彩红, 杨永坚.",
      "year": "2011",
      "title": "蚌埠地区中小学教师职业紧张状况调查",
      "journal": "中国学校卫生",
      "volume": "32",
      "number": "03",
      "pages": "301-303",
      "type": "journal"
    },
    {
      "authors": "Zhao W, Liao X, Li Q, et al.",
      "year": "2022",
      "title": "The relationship between teacher job stress and burnout: A moderated mediation model",
      "journal": "Frontiers in Psychology",
      "volume": "12",
      "pages": "784243",
      "type": "journal"
    },
    {
      "authors": "周翠.",
      "year": "2023",
      "title": "湖南省中小学教师职业紧张、抑郁的现状及关联研究",
      "journal": "长沙: 中南大学",
      "type": "d"
    },
    {
      "authors": "刘丹, 胡丽, 李爱华, 等.",
      "year": "2024",
      "title": "北京市中小学教师职业紧张现状及其影响因素分析",
      "journal": "首都公共卫生",
      "volume": "18",
      "number": "01",
      "pages": "27-31",
      "type": "journal"
    },
    {
      "authors": "赵丽敏, 张洁, 李云霞, 等.",
      "year": "2012",
      "title": "焦作市中小学教师职业紧张状况及其影响因素",
      "journal": "职业与健康",
      "volume": "28",
      "number": "11",
      "pages": "1285-1288",
      "type": "journal"
    },
    {
      "authors": "郭薇薇, 杨凤, 邸妞, 等.",
      "year": "2022",
      "title": "上海市中小学教师长工时现状及其健康影响研究",
      "journal": "中国工业医学杂志",
      "volume": "35",
      "number": "02",
      "pages": "151-155",
      "type": "journal"
    },
    {
      "authors": "Klaperski S.",
      "year": "2018",
      "title": "Exercise, stress and health: The stress-buffering effect of exercise",
      "journal": "Handbuch Stressregulation Und Sport",
      "pages": "227-249",
      "type": "journal"
    },
    {
      "authors": "Wettstein A, Schneider S, Grosse Holtforth M, et al.",
      "year": "2021",
      "title": "Teacher stress: A psychobiological approach to stressful interactions in the classroom",
      "journal": "Frontiers in Education",
      "volume": "6",
      "pages": "681258",
      "type": "conference"
    }
  ];

  return (
    <div className="references-container">
      <h1>相关文献</h1>
      <div className="references-description">
        <p>本研究基于以下文献进行设计与分析，这些研究为我们提供了重要的理论基础和方法论支持。</p>
      </div>
      <div className="references-list">
        {references.map((ref, index) => (
          <div key={index} className="reference-item">
            <div className="reference-number">{index + 1}</div>
            <div className="reference-content">
              <p>
                {ref.authors} {ref.title}[{ref.type[0].toUpperCase()}].{ref.journal}, {ref.year}, {ref.volume && `${ref.volume}`}{ref.number && `(${ref.number})`}:{ref.pages}.
                {ref.doi && (
                  <span className="doi">
                    <br />DOI: <a href={`https://doi.org/${ref.doi}`} target="_blank" rel="noopener noreferrer">{ref.doi}</a>
                  </span>
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default References; 